import styled from 'styled-components';

export const PublicRoutingBackground = styled.div`
  width: 100%;
  height: 100%;
  background: ${(props) => props.theme.atlas.semantic.color.surface.variant};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  overflow: auto;
`;
